import { connect } from 'react-redux';
import { fetchStudentEventTypes, fetchTeacherEventTypes } from '../actions/observations';
import ObservationDashboard from '../components/ObservationDashboard';

const mapStateToProps = (state) => {
	return {
		isFetchingEventTypes: state.observations.isFetchingEventTypes,
		selectedClassroom: state.classrooms.selected,
		studentEventTypes: state.observations.studentEventTypes,
		teacherEventTypes: state.observations.teacherEventTypes
	};
};

const mapDispatchToProps = {
	fetchStudentEventTypes,
	fetchTeacherEventTypes
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(ObservationDashboard);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/ObservationDashboard.jsx